import {createTransform} from 'redux-persist';

import {PanelConfig} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {PanelManagerState} from '~/frontend/src/reducers/panelManager';

// TODO: linter complains for wildcard but it's working... check how to solve this issue
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as panelTransformers from '~/frontend/src/transformers/panel';

// TODO: linter complains for wildcard but it's working... check how to solve this issue
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as moduleTransformers from '~/frontend/src/transformers/module';

/*
 *  Handles serialisation / de-serialisation of panelManager for redux persistence
 */
const panelManagerTransform = createTransform(
    ( inboundState : PanelManagerState ) : PanelManagerState => {
        const retVal = {
            ...inboundState
        };

        if ( retVal.openPanels.length ) {
            retVal.openPanels = ( [] as PanelConfig[] ).concat( retVal.openPanels );

            for ( let i = 0; i < retVal.openPanels.length; i++ ) {
                retVal.openPanels[ i ] = {
                    ...retVal.openPanels[ i ]
                };

                delete retVal.openPanels[ i ].isDirty;
                delete retVal.openPanels[ i ].isInvalid;
                retVal.openPanels[ i ].showConfirmCloseDialog = false;
                retVal.openPanels[ i ].showPanelPropsDialog = false;

                // panel data hydrate
                if ( retVal.openPanels[ i ].panelProps ) {
                    retVal.openPanels[ i ].panelProps = {
                        ...retVal.openPanels[ i ].panelProps
                    };
                    delete retVal.openPanels[ i ].panelProps.subPanelErrors;

                    if ( retVal.openPanels[ i ].panelProps.moduleTransformer ) {
                        const moduleTransformer = moduleTransformers[ retVal.openPanels[ i ].panelProps.moduleTransformer ];

                        if ( moduleTransformer?.hydrate ) {
                            retVal.openPanels[ i ].panelProps = moduleTransformer.hydrate( retVal.openPanels[ i ].panelProps );
                        }
                        else if ( moduleTransformer ) {
                            retVal.openPanels[ i ].panelProps = moduleTransformer( retVal.openPanels[ i ].panelProps );
                        }
                    }

                    if ( retVal.openPanels[ i ].panelProps.panelTransformer ) {
                        const panelTransformer = panelTransformers[ retVal.openPanels[ i ].panelProps.panelTransformer ];

                        if ( panelTransformer?.hydrate ) {
                            retVal.openPanels[ i ].panelProps = panelTransformer.hydrate( retVal.openPanels[ i ].panelProps );
                        }
                        else if ( panelTransformer ) {
                            retVal.openPanels[ i ].panelProps = panelTransformer( retVal.openPanels[ i ].panelProps );
                        }
                    }

                    // subPanel data hydrate
                    if ( retVal.openPanels[ i ].panelProps.subPanelProps ) {
                        retVal.openPanels[ i ].panelProps.subPanelProps = {
                            ...retVal.openPanels[ i ].panelProps.subPanelProps
                        };

                        const subPanelKeys = Object.keys( retVal.openPanels[ i ].panelProps.subPanelProps );
                        for ( const subPanelKey of subPanelKeys ) {
                            retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = {
                                ...retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ]
                            };

                            if ( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ].moduleTransformer ) {
                                const subModuleTransformer = moduleTransformers[ retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ].moduleTransformer ];

                                if ( subModuleTransformer?.hydrate ) {
                                    retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = subModuleTransformer.hydrate( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] );
                                }
                                else if ( subModuleTransformer ) {
                                    retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = subModuleTransformer( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] );
                                }
                            }

                            if ( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ].panelTransformer ) {
                                const subPanelTransformer = panelTransformers[ retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ].panelTransformer ];

                                if ( subPanelTransformer?.hydrate ) {
                                    retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = subPanelTransformer.hydrate( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] );
                                }
                                else if ( subPanelTransformer ) {
                                    retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = subPanelTransformer( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] );
                                }
                            }
                        }
                    }
                }
            }
        }

        return retVal;
    },
    ( outboundState : PanelManagerState ) : PanelManagerState => {
        const retVal = {
            ...outboundState
        };

        if ( retVal.openPanels.length ) {
            retVal.openPanels = ( [] as PanelConfig[] ).concat( retVal.openPanels );

            for ( let i = 0; i < retVal.openPanels.length; i++ ) {
                retVal.openPanels[ i ] = {
                    ...retVal.openPanels[ i ]
                };

                // panel data rehydrate
                if ( retVal.openPanels[ i ].panelProps ) {
                    retVal.openPanels[ i ].panelProps = {
                        ...retVal.openPanels[ i ].panelProps
                    };

                    const panelTransformer = panelTransformers[ retVal.openPanels[ i ].panelProps.panelTransformer ];
                    if ( panelTransformer?.rehydrate ) {
                        retVal.openPanels[ i ].panelProps = panelTransformer.rehydrate( retVal.openPanels[ i ].panelProps );
                    }

                    // subPanel data rehydrate
                    if ( retVal.openPanels[ i ].panelProps.subPanelProps ) {
                        retVal.openPanels[ i ].panelProps.subPanelProps = {
                            ...retVal.openPanels[ i ].panelProps.subPanelProps
                        };

                        const subPanelKeys = Object.keys( retVal.openPanels[ i ].panelProps.subPanelProps );
                        for ( const subPanelKey of subPanelKeys ) {
                            retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = {
                                ...retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ]
                            };

                            const subPanelTransformer = panelTransformers[ retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ].panelTransformer ];
                            if ( subPanelTransformer?.rehydrate ) {
                                retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] = subPanelTransformer.rehydrate( retVal.openPanels[ i ].panelProps.subPanelProps[ subPanelKey ] );
                            }
                        }
                    }
                }
            }
        }

        return retVal;
    },
    { whitelist: [ 'panelManager' ] }
);

export default panelManagerTransform;
